export const CLIENT_REST_ROUTE = {
    FREELANCER_TRUSTED: '/freelancers/ajax/trusted-freelancer',
    SELLER_NOTABLE_CLIENTS: '/freelancers/ajax/seller-notable-clients',
    SELLER_PAGE_DATA: '/freelancers/ajax/seller-page-data',
    GIGS_DATA: '/freelancers/ajax/get-gigs-data',
    GIGS_PACKAGE_DATA: '/freelancers/ajax/get-gigs-package-data',
    TRANSLATED_SKILLS: '/freelancers/ajax/get-translated-skills',
    PROFILE_PROGRESS_DELETE: '/freelancers/ajax/profile-progress-delete',
    TRANSLATED_ABOUT_EXPERT: '/freelancers/ajax/get-translated-about-expert',
    REVIEWS: '/freelancers/ajax/reviews',
    REVIEWS_TRANSLATIONS: '/freelancers/ajax/translate-reviews',
    LOCALIZATION_DATA: '/freelancers/ajax/seller-localization',
};
